/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentContributor } from './paymentContributor';
import { Price } from './price';
import { PaymentFrequency } from './paymentFrequency';
import { PaymentMethod } from './paymentMethod';
import { Product } from './product';

/**
 * Highest level in product hierarchy.  Defines a sellable product. Allows to bundle multiple products from different insurance sectors.   (bipro-produktmodell::Verkaufsprodukt)
 */
export interface SalesProduct {
  paymentMethod?: PaymentMethod;
  paymentFrequency?: PaymentFrequency;
  paymentContributor?: PaymentContributor;
  /**
   * Calculated prices for this product.  Currency is always euro and cent.   (german: Beitrag) (bipro-produktmodell::Beitrag)
   */
  prices?: Array<Price>;
  /**
   * One or more insurance products for a concrete insurance sector.
   */
  products: Array<Product>;
}
export namespace SalesProduct {}
